import { useContext } from 'react'
import type { TranslatorContextValue } from '@contexts/TranslatorContext'
import { TranslatorContext } from '@contexts/TranslatorContext'

export const useTranslator = (): TranslatorContextValue => {
  const contextValue = useContext(TranslatorContext)

  if (contextValue === null) {
    throw new Error('No "TranslatorContextProvider" configured')
  }

  return contextValue
}
